<template>
  <common-framework :name="'找回密码'">
    <div class="forgetPwd">
      <div class="returnLogin"><a href="" @click="jumpTolink('lylogin')" class="line">返回登录页</a></div>
      <div class="contents">
        <div class="cl">
          <p class="title">忘记密码？选择认证方式：</p> 
          <p class="subTitle" v-show="forgetPwd[0] && forgetPwd[0].isShow">{{forgetPwd[0].title}}</p>
          <div class="buttons">
            <div class="button" @click="jumpTolink('leyouauth-forget-mobile')">手机号验证</div>
            <div class="button" @click="jumpTolink('leyouauth-forget-email')">邮箱验证</div>
          </div>
        </div>
      </div>
    </div>    
  </common-framework>
</template>

<script>
  import { Button } from 'ant-design-vue';
  import CommonFramework from "../../shared/components/lyCommonFramework/index";
  import { http } from '../../shared/utils';
  
  export default {
    name: "forget",
    components: {
      Button,
      CommonFramework
    },
    data () {
      return {
        forgetPwd: [
          {
            title: ''
          }
        ]
      }
    },
    async mounted() {
      await this.getPop()
    },
    methods: {
      async getPop(){
        const res = await http.get('//cms.haiziwang.com/publish/976/door.json');
        if (res && res.data) {
          this.forgetPwd = res.data.isforgetPwd     
        }
      },
      jumpTolink (name) {
        this.$router.push({
          name
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

.forgetPwd {
  

  .returnLogin {
    text-align: right;
    padding: 40px 0;
    
    .line {
      text-decoration: underline;
    }

    a {
      text-decoration: none;
    }
  }

  .contents {
    display: flex;
    justify-content: center;
    text-align: center;
    
    .cl {
      text-align: center;
  
      .title {
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        margin-bottom: 40px;
      }

      .subTitle {
        height: 20px;
        font-size: 12px;
        color: #ccc;
        letter-spacing: 0;
        margin-bottom: 20px;
      }

      .buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .button {
        width: 260px;
        height: 44px;
        background: #F7F7F7;
        border: 1px solid #DBDBDB;
        border-radius: 4px;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        line-height: 44px;
        color: #333333;
        letter-spacing: 0;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>
